import { observer } from 'mobx-react';
import { storeKrunica } from '../../store/KrunicaStore';

function SlikaGospeNaslovna() {
  const { aktivnaZemlja, trenutnaKrunica } = storeKrunica;
  const {
    daniTjedan,
    otajstvoRadosna,
    otajstvoSlavno,
    otajstvoSvjetla,
    otajstvoZalosno,
    krunicaKrozKorizma,
    krunicaKrozBozic,
    krunicaKrozUskrs,
    krunice,
  } = aktivnaZemlja;

  // console.log(krunice, trenutnaKrunica);

  return (
    <div className="card">
      <div className="card__side card__side--front">
        <div className="card__picture card__picture--gospa"></div>
        <h4 className="card__heading">
          <span className="card__heading-span card__heading-span--1">
            {krunice.find((k) => k.value === trenutnaKrunica)?.label}
          </span>
        </h4>
        <div className="card__details">
          <ul>
            <li>{krunice.find((k) => k.value === trenutnaKrunica)?.pozdrav}</li>
          </ul>
        </div>
      </div>

      <div className="card__side card__side--back card__side--back-1 ">
        <div className="card__cta">
          <div className="card__price-box">
            <div className="text-srednji">
              <span className="dan">{daniTjedan[0].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoRadosna}</span>
            </div>
            <div className="text-srednji">
              <span className="dan">{daniTjedan[1].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoZalosno}</span>
            </div>
            <div className="text-srednji">
              <span className="dan">{daniTjedan[2].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoSlavno}</span>
            </div>
            <div className="text-srednji">
              <span className="dan">{daniTjedan[3].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoSvjetla}</span>
            </div>
            <div className="text-srednji">
              <span className="dan">{daniTjedan[4].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoZalosno}</span>
            </div>
            <div className="text-srednji">
              <span className="dan">{daniTjedan[5].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoRadosna}</span>
            </div>
            <div className="text-srednji">
              <span className="dan">{daniTjedan[6].label}</span>
              <span className="crtica">-</span>
              <span className="otajstvo">{otajstvoSlavno}</span>
            </div>
          </div>
          <div className="text-srednji-opis">{krunicaKrozKorizma}</div>
          <div className="text-srednji-opis">{krunicaKrozBozic}</div>
          <div className="text-srednji-opis">{krunicaKrozUskrs}</div>
          <div className="autor">alenskupnjak@yahoo.com</div>
          <div className="git">
            https://github.com/alenskupnjak/reactKrunica
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(SlikaGospeNaslovna);
